export const clearSearchParameters = (set: any) => {
  set({ searchParameters: {} })
}
